import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Subscription } from "rxjs";
import { first, map } from "rxjs/operators";
import {LfsaBotonEditarGridComponent} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UsuarioBasculaGaritaService } from '../../services/usuario-bascula-garita.service';
import { MantenimientoBasculaService } from '../../services/mantenimiento-bascula.service';
import { MantenimientoGaritasService } from '../../services/mantenimiento-garitas.service';
import { IGaritaResponse } from '../../modelos/IMantGarita';
import { IMantBascula } from '../../modelos/IMantBascula';
import { UsuariosService } from '../../services/usuarios.service';
import { IUsuarioAll } from '../../modelos/IUsuario.js';
import { Row, Workbook as wb, Worksheet } from "exceljs";
import { saveAs } from 'file-saver';
import { OrdenBalanzaService } from '../../services/orden-balanza.service';
import { Console } from 'console';
import { TipoOrdenesBalanzaService } from '../../services/tipo-ordenes-balanza.service';
import { ProveedorService } from '../../services/proveedor.service';

@Component({
  selector: 'app-reporte-qm',
  templateUrl: './reporte-qm.component.html',
  styleUrls: ['./reporte-qm.component.css']

})
export class ReporteQmComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.reporteCompras;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;
  public formulario: FormGroup;

  workbook: wb;
  data: any = [];
  dataExcel: any = [];

  cmbTipoPedido = [
    {id: '0', descripcion: 'Compra'},
    {id: '4', descripcion: 'Maquila'},
  ]

  public agregarForm = new FormGroup({
    tipoPedido: new FormControl('', []),
    tipoOrden: new FormControl('', []),
    cliente: new FormControl('', []),
    proveedor: new FormControl('', []),
    material: new FormControl('', []),
    idOrden: new FormControl('', []),
    fechaIngreso: new FormControl('', []),
    fechaFin: new FormControl('', []),
    pesoTotal: new FormControl('', []),
  });
  public cmbUsuarios: IUsuarioAll[] = [];
  private subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private basculaService: MantenimientoBasculaService,
    private garitasService: MantenimientoGaritasService,
    private usuariosService: UsuariosService,
    private ordenBalanzaService: OrdenBalanzaService,
    private tipoOrdenesBalanzaS: TipoOrdenesBalanzaService,
    private proveedorS: ProveedorService,
  ) {
  }

  get proveeControl() {
    return this.agregarForm.get('cliente_proveedor');
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();
    this.obtenerTipoOrdenBalanza();
    this.formulario = this.fb.group({
      year: ['', [Validators.required]],
      fecha: ['', [Validators.required,]]
    });
  }

  obtenerMantenimientoBascula() {
    this.basculaService.obtener()
      .pipe(
        map(m => m.filter(f => f.estado.toString() == 'ACTIVO'))
      )
      .subscribe(
        (resp) => {
          this.basculaSelect = resp;
          this.loading = false;
        },
        (error) => {
          this.basculaSelect = [];
          this.loading = false;
        }
      );
  }

  obtenerGaritas() {
    this.loading = true;
    this.garitasService.obtener()
      .pipe(
        map(m => m.filter(f => f.estado.toString() == 'ACTIVO'))
      )
      .subscribe(
        (resp) => {
          this.garitaSelect = resp;
          this.loading = false;
        },
        (error) => {
          this.garitaSelect = [];
          this.loading = false;
        }
      );
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Tipo Pedido',
        field: 'tipoDeOrdenDesc',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'Tipo Orden de Balanza',
        field: 'tipoOrden.desca',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Ticket Balanza',
        field: 'idOrden',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'N# Orden',
        field: 'ordenCompra.idOrd',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Proveedor',
        field: 'proveedor',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Material',
        field: 'material',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Peso Entrada.',
        field: 'pesoIn',
        sortable: true,
        filter: true,
      }, 
      {
        headerName: 'Peso Salida.',
        field: 'pesoOut',
        sortable: true,
        filter: true,
      }, 
      {
        headerName: 'Balanza',
        field: 'bascula.desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Centro Destino',
        field: 'centroDest',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Almacén Destino',
        field: 'almaceDest',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Pesador',
        field: 'idusuario',
        sortable: true,
        filter: true,
      },
    ];
  }

  pesoTotal = 0;
  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.ordenBalanzaService.obtener().subscribe(
        (resp) => {
          console.log(resp[0].tipoOrden.tipOrden)
          resp.map(item => {
            item["tipoDeOrdenDesc"] = "";
            switch (item.tipoOrden.tipOrden) {
              case 0: item["tipoDeOrdenDesc"] = "Compra"; break;
              case 1: item["tipoDeOrdenDesc"] = "Venta"; break;
              case 2: item["tipoDeOrdenDesc"] = "Traslado"; break;
              case 3: item["tipoDeOrdenDesc"] = "Informativo"; break;
              case 4: item["tipoDeOrdenDesc"] = "Maquila"; break;
              default: break;
            }
            let fechaIngreso = item["fechIn"].split("T")[0];
            let horaIngreso = item["fechIn"].split("T")[1];
            item["fechaIngreso"] = fechaIngreso.split("-")[2] + "-" + fechaIngreso.split("-")[1] + "-" + fechaIngreso.split("-")[0] + " " + horaIngreso;
            this.pesoTotal += parseFloat(item["pesoNeto"]) > 0 ? parseFloat(item["pesoNeto"]) : 0;
            return item;
          })
          console.log("resp", resp)
          console.log("pesoTotal", this.pesoTotal)
          this.agregarForm.get("pesoTotal").setValue(this.pesoTotal);
          this.obtenerMantenimientoBascula();
          this.obtenerGaritas();
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
  }

  descargarExcel() {
    this.generarEcxel();
  }

  generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
  
    this.rowData = this.rowData.map( item => {
      item.bloqueos = item.bloqueos.sort((a, b)=> b.id - a.id)[0];
      return item;
    });

    console.log("this.rowData", this.rowData);

    this.rowData.forEach(x => {
      let payload = {
        estado: x.estado,
        material: x.material,
        detalleMaterial: x.dscaMaterial,
        proveedor: x.proveedor,
        detalleProveedor: x.dscaProveedor,
        origen: x.origOrd != null ? x.origOrd + " - " + x.dscaOrigen : "",
        tipoDeOrdenDesc: x.tipoDeOrdenDesc,
        desca: x.tipoOrden.desca,
        idOrden: x.idOrden,
        numero: x.tipoOrden.tipOrden != 0 ? x.numOrdAlt : x.ordenCompra.idOrd,
        lote: x.loteInsp,
        fechaLote: x.fechaLoteIns,
        de: x.decisionEmpleo,
        fechaDe: x.fechaDecision,
        pesoNetoBalanza : Math.abs(x.pesoIn-x.pesoOut),
        acidezSap: x.acidezSap != null ? Number.parseFloat(x.acidezSap).toFixed(2) : "",
        acidez: x.acidez != null ? Number.parseFloat(x.acidez).toFixed(2) : "",
        difAcidez: x.bloqueos != null ? Math.abs(x.bloqueos.difAcidez) : "",
        humedadSap: x.humedadSap != null ? Number.parseFloat(x.humedadSap).toFixed(2) : "",
        humedad: x.humedad != null ? Number.parseFloat(x.humedad).toFixed(2) : "",
        difHumedad: x.bloqueos != null ? Math.abs(x.bloqueos.difHumedad ): "",
        impurezaSap: x.impurezaSap != null ? Number.parseFloat(x.impurezaSap).toFixed(2) : "",
        impureza: x.impureza != null ? Number.parseFloat(x.impureza).toFixed(2) : "",
        difImpureza: x.bloqueos != null ? Math.abs(x.bloqueos.difImpureza) : "",
        dobi: x.dobi != null ? Number.parseFloat(x.dobi).toFixed(2) : "",
        ir: x.nivelIR != null ? Number.parseFloat(x.nivelIR).toFixed(4) : "",
        tcalidad: x.tpDobi,
        pinspeccion: x.npunto,
        nivel: x.bloqueos != null ? x.bloqueos.nivel : "",
        autorizado: x.bloqueos != null ? x.bloqueos.autoriza : "",
        usuario: x.bloqueos != null ? x.bloqueos.usuarioAutoriza : "",
        bloqueoID: x.bloqueos != null ? x.bloqueos.id : "",
      };      
      this.dataExcel.push(payload);
    });
    console.log("this.dataExcel", this.dataExcel);
    this.fillExcelMarketplace();
    this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Reporte QM' + '.xlsx');
    });
  }
  public date = new Date();
  fillExcelMarketplace() {
    const nameSheet = 'Reporte';
    let header;
    let titulos;

    header = [
      'Estado Orden',
      'Material',
      'Descripción Material',
      'Proveedor',
      'Descripción Proveedor',
      'Origen',
      'Tipo Orden de Balanza',
      'Tipo Orden de Balanza',
      'N# Orden de Balanza',
      'N# Pedido-OC',
      'L.I',
      'FECHA Y HORA',
      'D.E',
      'FECHA Y HORA',
      'Peso Neto',
      'Acidez LFSA',
      'Acidez PROV',
      'Diferencia ACIDEZ',
      'Humedad LFSA',
      'Humedad PROV',
      'Diferencia HUMEDAD',
      'Impureza LFSA',
      'Impureza PROV',
      'Diferencia IMPUREZA',
      'DOBI',
      'I.R',
      'Tipo de Calidad',
      'Ingresos de resultados',
      'Nivel Aprobación',
      'Autorizado',
      'Usuario Kosmos (Autoriza desbloqueo)',
      'ID Registro de Bloqueo'
    ];

    titulos=["REPORTE INGRESO DE MATERIA PRIMA."];

    let row;
    let headerRow;
    let titulosRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left  : 0.3149606,
          right : 0.3149606,
          top   : 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    
    row = worksheet.getRow(1);
    titulosRow = worksheet.addRow(titulos);

    row = worksheet.getRow(2);
    titulosRow = worksheet.addRow([this.date]);

    row = worksheet.getRow(4);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 30;
    worksheet.columns[1].width = 10;
    worksheet.columns[2].width = 30;
    worksheet.columns[3].width = 10;
    worksheet.columns[4].width = 30;
    worksheet.columns[5].width = 30;
    worksheet.columns[6].width = 20;
    worksheet.columns[7].width = 30;
    worksheet.columns[8].width = 20;
    worksheet.columns[9].width = 10;
    worksheet.columns[10].width = 30;
    worksheet.columns[11].width = 10;
    worksheet.columns[12].width = 20;
    worksheet.columns[13].width = 20;
    worksheet.columns[14].width = 20;
    worksheet.columns[15].width = 15;
    worksheet.columns[16].width = 15;
    worksheet.columns[17].width = 15;
    worksheet.columns[18].width = 15;
    worksheet.columns[19].width = 15;
    worksheet.columns[10].width = 15;
    worksheet.columns[21].width = 15;
    worksheet.columns[22].width = 15;
    worksheet.columns[23].width = 15;
    worksheet.columns[24].width = 15;
    worksheet.columns[25].width = 15;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {vertical: 'middle', horizontal: 'right'};
      });
    });

    this.data = this.formatDataExcel();
    this.fillRows(worksheet);
    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }


  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'B7DEE8' },
            bgColor: { argb: 'FF0000FF' },
          };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatDataExcel(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }

  buscarReporte() {
    this.pesoTotal = 0;
    this.loading = true;

    let datos = this.agregarForm.getRawValue();

    if (
      (datos.cliente == "" || datos.cliente == null) &&
      (datos.idOrden == "" || datos.idOrden == null) &&
      (datos.material == "" || datos.material == null) &&
      (datos.fechaFin == "" || datos.fechaFin == null) &&
      (datos.tipoOrden == "" || datos.tipoOrden == null) &&
      (datos.proveedor == "" || datos.proveedor == null) &&
      (datos.tipoPedido == "" || datos.tipoPedido == null) &&
      (datos.fechaIngreso == "" || datos.fechaIngreso == null)
    ) {
      this.obtenerTodo();
      return;
    }

    let formdata = {
      "cliente": datos.cliente.toString(),
      "material": datos.material.toString(),
      "proveedor": datos.proveedor.toString(),
      "nrOrden": datos.idOrden ? parseInt(datos.idOrden) : null,
      "tipoOrdenBalanza": datos.tipoOrden ? datos.tipoOrden : null,
      "tipopedido": datos.tipoPedido != "" ? parseInt(datos.tipoPedido) : null,
      "fechaFin": datos.fechaFin ? datos.fechaFin + 'T' + '23:59:59' : "",
      "fechaInicio": datos.fechaIngreso ? datos.fechaIngreso + 'T' + '00:00:00' : "",
    };
    this.subscription.add(
      this.ordenBalanzaService.reporteria(
        formdata
      ).subscribe(
        (resp) => {
          if (resp.length > 0) {
            console.log(resp)
            console.log(resp[0].tipoOrden.tipOrden)
            resp.map(item => {
              item["tipoDeOrdenDesc"] = "";
              switch (item.tipoOrden.tipOrden) {
                case 0: item["tipoDeOrdenDesc"] = "Compra"; break;
                case 1: item["tipoDeOrdenDesc"] = "Venta"; break;
                case 2: item["tipoDeOrdenDesc"] = "Traslado"; break;
                case 3: item["tipoDeOrdenDesc"] = "Informativo"; break;
                case 4: item["tipoDeOrdenDesc"] = "Maquila"; break;
                default: break;
              }
              let fechaIngreso = item["fechIn"].split("T")[0];
              let horaIngreso = item["fechIn"].split("T")[1];
              item["fechaIngreso"] = fechaIngreso.split("-")[2] + "-" + fechaIngreso.split("-")[1] + "-" + fechaIngreso.split("-")[0] + " " + horaIngreso;
              this.pesoTotal += parseFloat(item["pesoNeto"]) > 0 ? parseFloat(item["pesoNeto"]) : 0;
              return item;
            })
          }
          this.agregarForm.get("pesoTotal").setValue(this.pesoTotal);
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  tiposDeOrdenesDeBalanza;
  tiposDeOrdenesDeBalanzaAuxilar;
  obtenerTipoOrdenBalanza() {
    this.loading = true;
    this.tipoOrdenesBalanzaS.obtener().subscribe(
      (resp) => {
        let rowData = resp;
        console.log("obtenerTipoOrdenBalanza", resp)
        rowData.forEach(item => {
          switch (item.tipOrden) {
            case 0:
              item.descTipOrden = "Compra";
              break;
            case 1:
              item.descTipOrden = "Venta";
              break;
            case 2:
              item.descTipOrden = "Traslado";
              break;
            case 3:
              item.descTipOrden = "Informativo";
              break;
            case 4:
              item.descTipOrden = "Maquila";
              break;
            default:
              item.descTipOrden = "";
              break;

              return item;
          }
        });

        let newFirstElement = { id: '', desca: 'Todos' };
        let newArray = [newFirstElement].concat(rowData);

        this.tiposDeOrdenesDeBalanza = newArray;
        this.tiposDeOrdenesDeBalanzaAuxilar = newArray;

        this.loading = false;
        console.log("this.rowData", newArray)
      },
      (error) => {
        this.tiposDeOrdenesDeBalanza = [];
        this.loading = false;
      }
    );
  }


  onChangeTipo(){
    let tipoFiltro = this.agregarForm.get("tipoPedido").value;
    let filTodos = { id: '', desca: 'Todos' };

    this.tiposDeOrdenesDeBalanza = this.tiposDeOrdenesDeBalanzaAuxilar;   
    this.tiposDeOrdenesDeBalanza = this.tiposDeOrdenesDeBalanza.filter(tipos => tipos.tipOrden == tipoFiltro);

    let newArray = [filTodos].concat(this.tiposDeOrdenesDeBalanza);
    this.tiposDeOrdenesDeBalanza = newArray;

  }

}
